import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import TradeView from '../views/TradeView.vue';
import Login from '../views/Login.vue';

import Settings from '../views/Settings.vue';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: '/webtrading',
        name: 'tradeview',
        component: TradeView,
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
    },

    {
        path: '/settings',
        name: 'settings',
        component: Settings,
    },

    {
        path: '/',
        name: 'home',
        component: Home,
    },
];

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
});

export default router;
